var _excluded = ["displayName", "defaultProps"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import deprecatedPropsLog from './deprecation-log.js';
import replacementPropsMap from './replacement-props-map.js';
var wrapString = function wrapString(str) {
  return typeof str === 'string' ? "\"".concat(str, "\"") : "{".concat(str, "}");
};
var createWarning = function createWarning(propName, propValue, componentName, replacementPropsAndValues) {
  var _deprecatedPropsLog$c;
  // deprecated code snippet
  var deprecatedCode = "`".concat(propName, "=").concat(wrapString(propValue), "`");
  // constuct console warning message
  var warningText = "DEPRECATION: Prop ".concat(deprecatedCode, " for `<").concat(componentName, ">` has been deprecated");
  // get "deprecated since" and "removal in" values (if available)
  var _ref = (deprecatedPropsLog === null || deprecatedPropsLog === void 0 || (_deprecatedPropsLog$c = deprecatedPropsLog[componentName]) === null || _deprecatedPropsLog$c === void 0 ? void 0 : _deprecatedPropsLog$c[propName]) || {},
    deprecatedInVersion = _ref.deprecated,
    removeInVersion = _ref.remove;
  if (deprecatedInVersion && removeInVersion) {
    warningText += " since ".concat(deprecatedInVersion, " and will be removed in ").concat(removeInVersion);
  }
  // preferred code snippet replacing deprecated props and values
  var preferredCode = Object.entries(replacementPropsAndValues).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return "".concat(key, "=").concat(wrapString(value));
  });
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production') {
    console.log(warningText, "\n    Please use `".concat(preferredCode, "` instead."));
  }
};
var hasDeprecatedValue = function hasDeprecatedValue(propValue, mappedProp) {
  if (typeof mappedProp === 'function') {
    return mappedProp(propValue) !== undefined;
  }
  return propValue !== null && propValue !== undefined;
};
var useDeprecatedProps = function useDeprecatedProps(props, componentName) {
  return Object.entries(props).reduce(function (curr, _ref4) {
    var _replacementPropsMap$;
    var _ref5 = _slicedToArray(_ref4, 2),
      propName = _ref5[0],
      propValue = _ref5[1];
    var mappedByPropName = replacementPropsMap === null || replacementPropsMap === void 0 || (_replacementPropsMap$ = replacementPropsMap[componentName]) === null || _replacementPropsMap$ === void 0 ? void 0 : _replacementPropsMap$[propName];
    // check if prop has been mapped and if a deprecated value has been passed
    if (mappedByPropName && hasDeprecatedValue(propValue, mappedByPropName)) {
      // mapped replacement prop(s) to deprecated prop value(s)
      var replacementPropsAndValues = {};
      // if map is a string, replace prop name only
      if (typeof mappedByPropName === 'string') {
        replacementPropsAndValues = _defineProperty({}, mappedByPropName, propValue);
      }
      // if map is an object, spread onto component
      else if (_typeof(mappedByPropName) === 'object') {
        replacementPropsAndValues = _objectSpread({}, mappedByPropName);
      }
      // if map is a function, mapping must be conditional
      else if (typeof mappedByPropName === 'function') {
        // get conditional mapping from function
        var mappedByPropValue = mappedByPropName(propValue);
        // if map is a string, replace prop value only
        if (typeof mappedByPropValue === 'string') {
          replacementPropsAndValues = _defineProperty({}, propName, mappedByPropValue);
        }
        // if map is an object, spread onto component
        else if (_typeof(mappedByPropValue) === 'object') {
          replacementPropsAndValues = _objectSpread({}, mappedByPropValue);
        }
      }
      // create deprecation console warning
      createWarning(propName, propValue, componentName, replacementPropsAndValues);
      return _objectSpread(_objectSpread({}, curr), replacementPropsAndValues);
    }
    // prevent default values on props from overwriting mapped props
    return _objectSpread(_objectSpread({}, curr), {}, _defineProperty({}, propName, curr.hasOwnProperty(propName) ? curr[propName] : propValue));
  }, {});
};
var withDeprecatedProps = function withDeprecatedProps(BaseComponent) {
  var displayName = BaseComponent.displayName,
    defaultProps = BaseComponent.defaultProps,
    other = _objectWithoutProperties(BaseComponent, _excluded);
  var WrappedComponent = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
    return /*#__PURE__*/React.createElement(BaseComponent, _extends({
      ref: forwardedRef
    }, useDeprecatedProps(props, displayName)));
  });
  WrappedComponent.defaultProps = defaultProps;
  WrappedComponent.displayName = displayName;
  Object.keys(other).forEach(function (key) {
    if (/^[A-Z]/.test(key)) {
      WrappedComponent[key] = BaseComponent[key];
    }
  });
  return WrappedComponent;
};
export default withDeprecatedProps;